export const state = {
    list: [],
};
